import { TransactionListHeaderComponent } from "../transaction-list-header.component";
import { AfterViewInit, Component } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { MasterdataService } from "@core-services/masterdata.service";
import { TranslationService } from "@core-services/translation.service";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { TradableListService } from "@main-services/currency/tradable_list.service";

import { FiatWalletService } from "@main-services/wallet/fiat_wallet.service";
import { Fiat } from "@models";
import { toCurrencyByFiatId, toEuroByFiatId } from "@helpers/tradable-convert";
import { FiatTransaction, IndexTransaction, RebalanceInformation } from "@models/transaction";
import { AccountService } from "@modules/account/services/account.service";
import { FiatService } from "@main-services/currency";
import { ContactService } from "@main-services/contact.service";
import { PayAccountService } from "@main-services/pay_account.service";
import { Observable } from "rxjs";
import { PortfolioFacade } from "@modules/portfolio/domain/portfolio.facade";
import { TRADE_TYPE } from "@models/trade-offer.model";

@Component({
	selector: "index-transaction-list-header",
	templateUrl: "./index-transaction-list-header.component.html",
	standalone: false
})
export class IndexTransactionListHeaderComponent extends TransactionListHeaderComponent implements AfterViewInit {
	private transactionFiat: Fiat = null;
	private rebalanceInformation: RebalanceInformation = new RebalanceInformation();

	public isHideValueActive$: Observable<boolean> = this.portfolioFacade.isPortfolioDataHidden$;
	public isIndexClaim: boolean = false;

	public constructor(
		protected modalService: ModalService,
		protected tradableWalletListService: TradableWalletListService,
		protected tradableListService: TradableListService,
		protected accountService: AccountService,
		protected fiatWalletService: FiatWalletService,
		protected fiatService: FiatService,
		protected contactService: ContactService,
		protected masterdataService: MasterdataService,
		protected payaccountService: PayAccountService,
		protected translationService: TranslationService,
		private readonly portfolioFacade: PortfolioFacade
	) {
		super(
			modalService,
			tradableWalletListService,
			tradableListService,
			fiatWalletService,
			fiatService,
			contactService,
			masterdataService,
			payaccountService,
			translationService
		);
	}

	public ngAfterViewInit(): void {
		if (this.transaction instanceof IndexTransaction && this.isRebalancingTx()) {
			this.rebalanceInformation = this.transaction.getRebalanceInformation();
		}
		// Show different symbol and colour for Index Claim
		this.isIndexClaim = this.transaction.getType() === "claim";
		super.ngAfterViewInit();
	}

	public isRebalancingTx(): boolean {
		return this.transaction.isRebalancingTx();
	}

	// ------------------ getter for rebalancing information

	public getRebalancedTx(): number {
		return this.rebalanceInformation.getRebalanced();
	}

	public getAddedTx(): number {
		return this.rebalanceInformation.getAdded();
	}

	public getRemovedTx(): number {
		return this.rebalanceInformation.getRemoved();
	}

	// -------------------

	private setTransactionFiat(): void {
		this.transactionFiat = this.fiatService.getItemById(this.fiatWallet.getFiatId());
	}

	private getTransactionFiat(): Fiat {
		if (!this.transactionFiat) {
			this.setTransactionFiat();
		}
		return this.transactionFiat;
	}

	public getIconSuffix(): string {
		if (this.transaction.getType() === TRADE_TYPE.CLAIM) {
			return TRADE_TYPE.SELL;
		}
		return this.transaction.getType();
	}

	public getFiat(): Fiat {
		return this.transaction instanceof FiatTransaction ? this.getTransactionFiat() : this.fiat;
	}

	public getTotalAmount(): string {
		if (this.transaction.getFiatId() !== this.getFiat().getId()) {
			const euroAmount: number = toEuroByFiatId(this.transaction.getAmount(), this.getTransactionFiat());
			if (this.getFiat().getId() === "1") {
				return "" + euroAmount;
			}
			return "" + toCurrencyByFiatId(euroAmount, this.getFiat());
		}
		return "" + this.transaction.getAmount();
	}

	public showIndexIcon(): boolean {
		return (
			(this.isActivityOrHistory() || this.transaction instanceof FiatTransaction) &&
			this.canOpen &&
			!this.isRebalancingTx()
		);
	}

	public isOutgoing(): boolean {
		if (this.transaction instanceof FiatTransaction) {
			return this.transaction.getType() === "buy";
		}
		return this.transaction.isOutgoing();
	}
}
